import Marquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

const ITEMS = [
  "Gourmet Hot Dogs",
  "Late Night Cart",
  "Catering & Events",
  "Neon Relish",
  "All-Beef Franks",
  "Disco Fries",
  "Toasted Brioche",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="bg-disco-yellow border-y-2 border-black/30 overflow-hidden">
      <Marquee speed={26} gradient={false} className="py-3">
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-display uppercase tracking-wider text-2xl text-disco-void px-6">
              {item}
            </span>
            <Sparkles size={16} className="text-disco-void/70" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
